export default __webpack_public_path__ + "media/images/icons/error-25502e1d5c53f5cfc8bdc17bb4fba70b.png";